export function SkeletonRow({ count = 5 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }).map((_, idx) => (
        <div
          key={idx}
          className={`grid grid-cols-2 ${
            idx % 2 === 0 ? 'bg-white' : 'bg-[#F8F9F9]'
          }`}
        >
          <div className="p-2 ps-5 text-xs">
            <div className="h-4 bg-gray-300 rounded w-3/4 animate-pulse" />
          </div>
          <div className="p-2 ps-5 text-xs">
            <div className="h-4 bg-gray-300 rounded w-1/2 animate-pulse" />
          </div>
        </div>
      ))}
    </>
  );
}